import { createFileRoute } from "@tanstack/react-router";
import AdminParts from "@/pages/admin/AdminParts";

export const Route = createFileRoute("/_adminLayout/admin/parts/")({
  component: AdminParts,
});
